var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "edition_1-line-10") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 13.2v-5.7c0-3.85-3.15-7-7-7s-7 3.15-7 7v5.7c-2.15 1.9-3.5 4.7-3.5 7.8 0 5.8 4.7 10.5 10.5 10.5s10.5-4.7 10.5-10.5c0-3.1-1.35-5.9-3.5-7.8zM10 7.5c0-3.3 2.7-6 6-6s6 2.7 6 6v4.9c-1.7-1.2-3.75-1.9-6-1.9s-4.3 0.7-6 1.9v-4.9zM16 30.5c-5.25 0-9.5-4.25-9.5-9.5s4.25-9.5 9.5-9.5 9.5 4.25 9.5 9.5-4.25 9.5-9.5 9.5zM20.45 20.5c-0.25-2.1-1.9-3.75-3.95-3.95v-2.55h-1v2.55c-2.1 0.25-3.75 1.9-3.95 3.95h-2.55v1h2.55c0.25 2.1 1.9 3.75 3.95 3.95v2.55h1v-2.55c2.1-0.25 3.75-1.9 3.95-3.95h2.55v-1h-2.55zM16 24.5c-1.95 0-3.5-1.55-3.5-3.5s1.55-3.5 3.5-3.5c1.95 0 3.5 1.55 3.5 3.5s-1.55 3.5-3.5 3.5z",
    fill: "#ffffff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.ea4a69a58d1bc6f0b309b4fff1609ba2.svg";
export { ForwardRef as ReactComponent };